import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Product from './Product';
import Navbar from './Navbar';
import './productList.css';
import leftIcon from'./images/left-icon.png'
import Footer from './Footer';


const ProductDetails = () => {
    const params = useParams();
    const product_url = "https://fakestoreapi.com/products";
    const [product, setProduct]=useState([]);
    
    useEffect(()=>{
        fetch(`${product_url}/${params.productId}`)
        .then((response)=>response.json())
        .then((product)=>setProduct(product))
    } , [params.productId]);

  return (
   <div className='product-details'>
     <div className='products-list'>
      <div className='navbar-custom'><Navbar/></div>
      <Link to="/" className='single-product'>
      <img src={leftIcon} alt='pic here'></img>
      </Link>
      <div className='product-d container'>
  
        <Product product={product} showBtn={false}/>  
      </div>
      <Footer/>
    </div> 
   </div>
  )
}

export default ProductDetails;